export const iconFontAwesomeMapsGavel = (
	<i className="fa-solid fa-gavel"></i>
);
